import React from 'react'
import ScrollToTop from './utils/ScrollToTop'
import { Route, Routes } from 'react-router-dom'
import Dashboard from './pages/Dashboard'
import Login from './pages/Login'
import 'chart.js/auto';
import { Toaster } from 'react-hot-toast'
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/js/plugins/align.min.js';
import 'froala-editor/js/plugins/colors.min.js';
import 'froala-editor/js/plugins/font_family.min.js';
import 'froala-editor/js/plugins/font_size.min.js';
import 'froala-editor/js/plugins/lists.min.js';
import 'froala-editor/js/plugins/paragraph_format.min.js';
import 'froala-editor/js/plugins/paragraph_style.min.js';
import "froala-editor/css/plugins/colors.min.css";
import RedirectLogin from './pages/RedirectLogin'


function App() {
  return (
    <div className="w-full relative">
      <ScrollToTop>
        <Routes>
          <Route path='/*' element={<Dashboard />} />
          <Route path='/login' element={<Login />} />
          <Route path='/auth/redirect' element={<RedirectLogin />} />
        </Routes>
      </ScrollToTop>
      <Toaster />
    </div>
  )
}

export default App